module.exports = __webpack_public_path__ + "img/lifted_print.256eea35.jpg";